export default "__VITE_ASSET__BLn1ohdH__"